import { formatDate } from './global-actions';

const Signature = ({ data }) => 
    <div className="signature" style={{ background: `url('data:image/jpeg;base64,${data}')` }}>
    </div>

export function getDocumentData( option, data ) {
    if(data){
        data.clientName = data.client.clientId.firstName + ' ' + data.client.clientId.lastName;
        data.attorneyName = data.attorneyInCharge.userId.firstName + ' ' + data.attorneyInCharge.userId.lastName;
    }
    //console.log(data);

    switch (option) {
        case 'authority':
            return authorityDocument(data)
        case 'policy':
            return policyDocument(data)
        case 'defense':
            return defenseDocument(data)
        case 'fee':
            return feeDocument(data)
        case 'legality':
            return legalityDocument(data)
      default:
        return ''
    }
}

const authorityDocument = ( data ) => (
    <div id="capture" style={{textAlign: 'justify', fontSize: '0.9em', lineHeight: 1.2}}>
        Señores<br/>
        {data.researchOrgan.organId.description}<br/>
        {data.city}, {data.province}<br/>
        <br/>
        PODERDANTE: {data.clientName.toUpperCase()}<br/>
        APODERADO: {data.attorneyName.toUpperCase()}<br/>
        ASUNTO: PODER ESPECIAL<br/>
        RADICADO: {data.filingNumber}<br/>
        <br/>
        <br/>
        <p style={{ overflowWrap: 'break-word'}}>
            {data.client.clientId.clientType === "juridica"?
                <span>
                    <b>{data.clientName}</b> representado(a) legalmente por <b>{data.client.clientId.manager}</b>,
                    identificado(a) con documento abajo indicado,
                </span>
                : 
                <span>
                    <b>{data.clientName}</b> mayor de edad, domiciliado(a) y residente en la ciudad de <b>{data.currentCity}</b>, <b>{data.currentProvince}</b>,
                    identificado(a) con documento abajo indicado, actuando en nombre propio,
                </span> 
            }
            &nbsp;manifiesto a usted señores <b>{data.researchOrgan.organId.description}</b> que confiero Poder Especial, Amplio y Suficiente a <b>{data.attorneyName.toUpperCase()}</b>, 
            con <b>{data.attorneyInCharge.userId.documentType}</b> No. <b>{data.attorneyInCharge.userId.document}</b>, Tarjeta
            Profesional No. <b>{data.attorneyInCharge.userId.professionalCard}</b> del Consejo Superior de la Judicatura; mayor de edad, domiciliado y residente 
            en Cali, para que de manera profesional me represente ante el despacho frente a la investigación de tipo <b>{data.caseType}</b> que 
            se aperturó en mi contra con radicado <b>{data.filingNumber}</b>.
        </p> 
        <br/>
        <br/>
        Mi apoderado está facultado para representar mis intereses, conciliar, desistir, sustituir, reasumir, transigir, solicitar pruebas, 
        aportar pruebas, realizar seguimiento a mi investigación, y en general para obrar con todas las facultades inherentes al mandato 
        que se le otorga para la defensa de mis intereses y derechos, de acuerdo con lo preceptuado por la normatividad vigente sobre la materia.
        <br/>
        <br/>
        <br/>
        Atentamente,<br/>
        <br/>
        <br/>
        <br/>
        <br/>
        {data.client.clientId.clientType === "juridica"?
            <span>
                {data.client.clientId.manager.toUpperCase()}<br/>
                {data.client.clientId.managerDocumentType} No {data.client.clientId.managerDocument}<br/>
                {data.client.clientId.managerEmail}<br/>
            </span>
            : 
            <span>
                {data.clientName.toUpperCase()}<br/>
                {data.client.clientId.documentType} No {data.client.clientId.document}<br/>
                {data.client.clientId.email}<br/>
            </span> }
        <br/>
        <br/>
        <br/>
        Acepto,<br/>
        <br/>
        <br/>
        <br/>
        <br/>
        {data.attorneyName.toUpperCase()}<br/>
        {data.attorneyInCharge.userId.documentType} No {data.attorneyInCharge.userId.document}<br/>
        TP No {data.attorneyInCharge.userId.professionalCard} del C.S. Judicatura<br/>
        {data.attorneyInCharge.userId.email}<br/>
    </div>
);

const policyDocument = ( data ) => (
    <div id="capture" style={{textAlign: 'justify', fontSize: '0.9em', lineHeight: 1.2}}>
        {data.city}, {formatDate(data.date, 3)}<br/>
        <br/>
        <br/>
        Señores<br/>
        {data.company.companyId.description}<br/>
        {data.company.companyId.city}<br/>
        <br/>
        Referencia: Notificación siniestro y afectación Póliza RC Servidores Públicos {data.case.statePosition === 'ex'? 'ex ':''}<b>{data.case.position}</b> de <b>{data.case.executionCity}</b> - <b>{data.clientName}</b> Exp. <b>{data.filingNumber}</b>
        <br/>
        <br/>
        Cordial saludo,
        <br/>
        <br/>
        Me permito remitir a continuación los documentos necesarios para afectar la póliza de
        Seguros RSC Servidores Públicos del investigado de la referencia:
        <br/>
        <br/>
        <ol>
            <li>Copia del Auto de apertura de investigación <b>No.{data.autoOpening}</b> del {formatDate(data.autoOpeningDate, 3)}</li>
            <li>Copia del envío para notificación del proceso del <b>{formatDate(data.notificationDate, 1)}</b></li>
            <li>Copia de los documentos del investigado <b>{data.clientName}</b>:</li>
            <ol>
                <li>Cedula de ciudadanía</li>
                <li>Acta de posesión de la fecha de los hechos que originaron el proceso</li>
                <li>Manual de funciones puntualizando las funciones- Certificado laboral</li>
            </ol>
            <li>Copia del Poder otorgado al abogado</li>
            <li>Informe de abogado estrategia de defensa y acciones adelantadas</li>
            <li>Cotización de honorarios</li>
            <li>Hoja de Vida del abogado suscrito</li>
            <li>Copia de los documentos del abogado</li>
            <ol>
                <li>Copia de la C.C.</li>
                <li>Copia de la Tarjeta profesional y vigencia de la misma</li>
                <li>Copia del RUT del abogado</li>
            </ol>
            <li>Constancia bancaria con No. de cuenta y vigencia.</li>
        </ol>
        Cualquier comunicación relacionada con este asunto, autorizo notificaciones al correo 
        electrónico <b>{data.attorneyInCharge.userId.email}</b> teniendo como datos de contacto los descritos al
        pie de página de esta solicitud. <br/>
        <br/>
        <br/>
        <Signature data={data.attorneyInCharge.userId.signature}/>
        {data.attorneyName.toUpperCase()}<br/>
        {data.positionText} <br/>
        {data.attorneyInCharge.userId.documentType} No {data.attorneyInCharge.userId.document} de Cali<br/>
        TP No {data.attorneyInCharge.userId.professionalCard} del C.S. Judicatura<br/>
        {data.attorneyInCharge.userId.email}<br/>
    </div>
);

const defenseDocument = ( data ) => (
    <div id="capture" style={{textAlign: 'justify', fontSize: '0.9em', lineHeight: 1.2}}>
        {data.city}, {formatDate(data.date, 3)}<br/>
        <br/>
        <br/>
        Señores<br/>
        {data.case.territorialEntity.toUpperCase()} DE {data.case.executionCity.toUpperCase()} {data.case.executionProvince.toUpperCase()}<br/>
        {data.company.companyId.description}<br/>
        {data.company.companyId.city}<br/>
        <br/>
        <p style={{ overflowWrap: 'break-word'}}>
            Referencia: Informe de acciones adelantadas y estrategia de defensa en investigación de responsabilidad <b>{data.caseType}</b> en 
            contra de <b>{data.clientName}</b> Exp. <b>{data.filingNumber}</b>
        </p>
        <br/>
        <br/>
        Cordial saludo,
        <br/>
        <br/>
        <p style={{ overflowWrap: 'break-word'}}>
            Para  <b>{data.legalCompanyText}</b> es muy grato presentar a usted(es) el siguiente informe de las acciones 
            adelantadas, y de la estrategia de defensa para asumir el proceso de responsabilidad <b>{data.caseType}</b> que se identifica con 
            el expediente número <b>{data.filingNumber}</b> por parte de <b>{data.researchOrgan.organId.description}</b>, contra el {data.case.statePosition === 'ex'? 'ex ':''} servidor 
            público <b>{data.clientName}</b>, en su calidad de {data.case.statePosition === 'ex'? 'ex ':''} <b>{data.case.position}</b> de <b>{data.case.executionCity}</b>, en procura de la exoneración de 
            responsabilidad en el presente caso. 
        </p>
        <br/>
        <br/>
        <b>ESTRATEGIA DE DEFENSA</b><br/>
        Desde la práctica profesional, como asesores jurídicos&nbsp;
        {data.caseType === 'fiscal'? 
            <span>
                en juicios de responsabilidad fiscal
            </span>
        :null}
        {data.caseType === 'sancionatoria'? 
            <span>
                en juicios de responsabilidad fiscal sancionatoria
            </span>
        :null}
        {data.caseType === 'disciplinaria'? 
            <span>
               disciplinarios
            </span>
        :null}
        , nos hemos enfrentado al problema de la violación al debido proceso, debido a que en muchas ocasiones no se garantiza 
        por parte de quienes operan la investigación corresponidente, siendo nuestra obligación demostrar que los hechos y las 
        presuntas imputaciones, no prosperen en contra del investigado, procurando una defensa justa y eficaz. 
        <br/>
        <br/>
        De este modo se evidencia que el ordenamiento&nbsp;
        {data.caseType === 'fiscal'? 
            <span>
                de responsabilidad fiscal
            </span>
        :null}
        {data.caseType === 'sancionatoria'? 
            <span>
                de responsabilidad fiscal sancionatoria
            </span>
        :null}
        {data.caseType === 'disciplinaria'? 
            <span>
               disciplinario
            </span>
        :null}
        , presenta vacíos en cuanto al ejercicio del derecho a la defensa para quienes se hallan inmersos en una investigación 
        de este tipo, menoscabando así su derecho fundamental al debido proceso.
        <br/>
        <br/>
        Para nosotros, como asesores jurídicos {data.caseType === 'disciplinaria'? 'disciplinarios': null}, es de vital importancia que dentro de las actuaciones realizadas en los procesos 
        ordinarios y/o verbales que adelantamos, se garantice de manera efectiva la defensa técnica de los {data.caseType === 'disciplinaria'? 'disciplinados': 'investigados'}, al considerar que en un 
        Estado Social de Derecho como lo es el nuestro, priman por sobre todas las cosas los preceptos de la dignidad humana.
        <br/>
        <br/>
        Dentro de la estrategia del defensor&nbsp;
        {data.caseType === 'fiscal'? 
            <span>
                en estos juicios de responsabilidad fiscal
            </span>
        :null}
        {data.caseType === 'sancionatoria'? 
            <span>
                en estos juicios de responsabilidad fiscal sancionatoria
            </span>
        :null}
        {data.caseType === 'disciplinaria'? 
            <span>
               disciplinario
            </span>
        :null}
        , se debe enaltecer el respeto al debido proceso, consagrado en el artículo 29 de la Carta Magna y definido por la 
        Corte como: <i>“El derecho que tienen las partes de hacer uso del conjunto de las facultades y garantías que el ordenamiento 
        jurídico les otorga, para efecto de hacer valer sus derechos sustanciales, dentro de un procedimiento judicial o administrativo”.</i>
        <br/>
        <br/>
        {data.caseType === 'disciplinaria'? 
            <span>
                Por otra parte, el Código General Disciplinario Ley 1952 de 2019 y Ley 2094 de 2021, establecen el debido proceso como: “El sujeto disciplinable deberá ser investigado por funcionario competente y con observancia formal y material de las normas que determinen la ritualidad del 9 Ibídem,  proceso, en los términos de este código y de la ley que establezca la estructura y organización del Ministerio Público”. Es así como el derecho al debido proceso constituye una aplicación del principio de legalidad dentro de un proceso judicial o administrativo, el cual busca garantizar que la actuación de las autoridades estatales siga el conjunto de reglas procesales establecidas de antemano. De este modo se desprenden tres principios jurídicos fundamentales: La seguridad jurídica, la legalidad de los procedimientos y la igualdad de las personas frente a la ley. Lo anterior se en el principio constitucional de la Dignidad Humana, plasmado en el artículo 1 de la Ley 1952 del 2019 “Quien intervenga en la actuación disciplinaria será tratado con el respeto debido a la dignidad humana”.
            </span>
        :
            <span>
                Por otra parte, el artículo 2 de la Ley 610 de 2000, establece los prinicipios orientadores de la acción fiscal, señalando <i>“En el ejercicio de 
                la acción de responsabilidad fiscal se garantizará el debido proceso y su trámite se adelantará con sujeción a los principios 
                establecidos en los artículos 29 y 209 de la Constitución Política y a los contenidos en el Código Contencioso Administrativo"</i>. Es así como el derecho 
                al debido proceso constituye una aplicación del principio de legalidad dentro de un proceso judicial o administrativo, el cual busca garantizar 
                que la actuación de las autoridades estatales siga el conjunto de reglas procesales establecidas de antemano. De este modo se desprenden tres principios 
                jurídicos fundamentales: La seguridad jurídica, la legalidad de los procedimientos y la igualdad de las personas frente a la ley.
            </span>
        }
        <br/>
        <br/>
        Existen ciertos elementos que estructuran la garantía del debido proceso, los cuales hacen parte de la estrategia a seguir en la presente 
        actuación administrativa, y que son fundamentales para garantizar una defensa técnica efectiva:
        <br/>
        <ul>
            <li>La definición de los elementos básicos que estructuran cualquier relación jurídica, 
                señalando tanto los supuestos relevantes para reconocer una conducta como jurídicamente significativa, como los efectos que se siguen de su incumplimiento.</li>
            <li>La identificación de la autoridad que es el tercero imparcial competente para adoptar 
                las decisiones relativas a los desacuerdos que surjan en la relación jurídica.</li>
            <li>La existencia de medios jurídicos que se puedan emplear en los casos en los que quienes hacen parte de una 
                determinada relación jurídica estiman necesario la intervención de un tercero para resolver las posibles diferencias que se originan 
                en dicha relación jurídica.</li>
            <li>El conocimiento por parte de todos los interesados, tanto de los elementos que estructuran la relación jurídica que 
                se establece y sus efectos concretos, como de los remedios jurídicos de los que gozan las partes para proteger sus intereses.</li>
            <li>El efectivo ejercicio de las herramientas jurídicas con las que el interesado puede adelantar su defensa ante 
                las autoridades o terceros.</li>
        </ul>
        Dentro de mis deberes como abogado en el presente caso, estaré en procura de: 
        <ol>
            <li>Asegurar por todos los medios lícitos y éticos para que los intereses puestos a nuestro cuidado sean respetados 
                y sufran los menores perjuicios.</li>
            <li>Atender con debida diligencia y cuidado el desenvolvimiento de todo el proceso asistiendo a las diligencias, 
                interponiendo los recursos necesarios, vigilando el cumplimiento de los términos, solicitando la práctica de las pruebas, etc. </li>
            <li>Ser leal en la defensa de nuestro poderdante sin entrar en componenda o arreglos con los funcionarios ni con 
                las otras partes en perjuicio de la recta administración de justicia o de su cliente.</li>
        </ol>
        {data.caseType === 'sancionatoria'? 
            <span>
                Al tratarse de un proceso sancionatorio fiscal, se tiene como premisa que el servidor público debe estar presto siempre a suministrar la información, que por regla general es la principal causa de apertura de este tipo de procesos, en tanto es considerado una obstrucción al ejercicio del control fiscal. 
                <br/>
                <br/>
                Es importante también tener en cuenta que el incumplimiento de la obligación de suministrar información a la Contraloría General de la República, se origina por las siguientes causas:  No rendir la cuenta, No rendir los informes exigidos, No rendir la cuenta en la forma y oportunidad establecidos por la Contraloría, No rendir los informes en la forma y oportunidad establecidos por la Contraloría, incurrir reiteradamente en errores en la cuenta, Incurrir reiteradamente en errores en los informes y determinar glosas de forma en la revisión de sus cuentas. 
                <br/>
                <br/>
                Sin embargo, por tratarse de conductas autónomas e independientes, durante un periodo fiscal bien puede haberse incurrido en varias de las causales señaladas, circunstancia que conlleva el adelantamiento de acciones independientes para la imposición de una sanción, por cada una de las infracciones, sin ello signifique el desconocimiento del principio <i>Non bis in ídem.</i> <br/><br/>
            </span>
            :null}
        <p style={{ overflowWrap: 'break-word'}}>
            {data.summary}
        </p>
        {data.caseType === 'fiscal'? 
            <span>
                En este sentido, uno de los enfoques que se tiene para la defensa, como parte de la estrategia misma, es enaltecer por encima de todo la 
                inexistencia del detrimento patrimonial, acreditando el cumplimiento del deber que le correspondía al ordenador del gasto y por ende, 
                entregándole al ente investigador y fiscalizador las pruebas debidas para exonerar a nuestro prohijado de toda responsabilidad.  
            </span>
            :''}
        {data.caseType === 'sancionatoria'? 
            <span>
                En este sentido, uno de los enfoques que se tiene para la defensa, como parte de la estrategia misma, es enaltecer por encima de 
                todo la INEXISTENCIA DE LA CULPA, como elemento subjetivo de la responsabilidad fiscal, toda vez que los procesos sancionatorios se 
                encuentran como una categoría del derecho de responsabilidad fiscal regulados en el CPACA y por la Ley 2080 del 2021, donde presta particular 
                relevancia este tipo de procedimientos.  
            </span>
            :''}
        {data.caseType === 'disciplinaria'? 
            <span>
                En este sentido, uno de los enfoques que se tiene para la defensa, como parte de la estrategia misma, es enaltecer por encima de todo 
                la inexistencia de la ilicictud sustancial en el cumplimiento del deber que le correspondía. El ejercicio de la función pública debe 
                estar enfocada al cumplimiento de los fines esenciales del Estado, destacándose los previstos en el artículo 2º C.P. Para cumplir con 
                esta objetivo, la actividad de los servidores públicos debe guiarse tanto por los deberes específicos que le imponen a cada empleo el 
                orden jurídico aplicable como, de una forma más amplia, los principios generales del ejercicio de la función pública, esto es, igualdad, 
                moralidad, eficacia, economía, celeridad, imparcialidad y publicidad (Art. 209 C.P.)
                <br/>
                <br/>
                Lo que se procura en la defensa, es acreditar el cumplimiento de esas reglas y principios, que en caso de no hacerse efectivas, activan 
                la actividad sancionatoria propia del derecho disciplinario.  Como lo ha explicado la jurisprudencia constitucional, el presupuesto para 
                la existencia de una falta disciplinaria es la acreditación acerca del incumplimiento de un deber funcional del servidor público o, en 
                otras palabras, la presencia de una conducta u omisión que interfiere en el ejercicio adecuado de la función estatal ejercida por dicho 
                servidor del Estado, situación que deberá demostrarse como tal, dentro de la estrategia de defensa. 
            </span>
            :''}
        <br/>
        <br/>
        <b>ACCIONES ADELANTADAS</b><br/>
        Dentro de las acciones adelantadas en la actualidad se tienen:<br/>
        {data.caseType === 'fiscal'? 
            <ol>
                <li>Diagnóstico y análisis del caso en particular.</li>
                <li>Recopilación de la información y pruebas para sustentar actuaciones disciplinables.</li>
                <li>Reuniones físicas y virtuales con el investigado para estructurar las respuestas y recopilar el acervo probatorio.</li>
                <li>Sustentación y elaboración de escrito para presentar los alegatos de conclusión en audiencia verbal y preparación de los recurso a que haya lugar.</li>
                <li>Preparación de hoja de ruta para sustentar en los descargos.</li>
                <li>Participación en la practica de pruebas, en especial de las declaraciones juramentadas solicitadas.</li>
                <li>Reunión con funcionarios y contratistas responsables de la parte operativa y otros investigados.</li>
            </ol>
            :''}
        {data.caseType === 'sancionatoria'? 
            <ol>
                <li>Diagnóstico y análisis del caso en particular.</li>
                <li>Recopilación de la información.</li>
                <li>Obtención de pruebas para sustentar actuaciones procesales.</li>
                <li>Reuniones físicas y virtuales con el investigado para estructurar las respuestas y recopilar el acervo probatorio.</li>
                <li>Sustentación y elaboración de escrito para presentar como versión libre.</li>
                <li>Recopilación de la información.</li>
                <li>Presentación de alegatos de conclusión</li>
                <li>Reunión con funcionarios y contratistas responsables de la parte operativa.</li>
                <li>Articulación con los investigados y responsables del asunto.</li>
            </ol>
            :''}
        {data.caseType === 'disciplinaria'? 
            <ol>
                <li>Diagnóstico y análisis del caso en particular.</li>
                <li>Recopilación de la información y pruebas para sustentar actuaciones disciplinables.</li>
                <li>Reuniones físicas y virtuales con el investigado para estructurar las respuestas y recopilar el acervo probatorio.</li>
                <li>Sustentación y elaboración de escrito para presentar como versión libre.</li>
                <li>Reunión con funcionarios y contratistas responsables de la parte operativa.</li>
            </ol>
            :''}
        <br/>
        <div>
            Coordialmente, 
            <br/>
            <Signature data={data.attorneyInCharge.userId.signature} />
            {data.attorneyName.toUpperCase()}<br/>
            {data.positionText} <br/>
            {data.attorneyInCharge.userId.documentType} No {data.attorneyInCharge.userId.document} de Cali<br/>
            TP No {data.attorneyInCharge.userId.professionalCard} del C.S. Judicatura<br/>
            {data.attorneyInCharge.userId.email}<br/>
        </div>
    </div>
);

const feeDocument = ( data ) => (
    <div id="capture" style={{textAlign: 'justify', fontSize: '0.9em', lineHeight: 1.2}}>
        {data.city}, {formatDate(data.date, 3)}<br/>
        <br/>
        <br/>
        Señores<br/>
        <b>{data.clientName}</b><br/>
        <b>{data.company.companyId.description}</b> <br/>
        <b>{data.company.companyId.city}</b> <br/>
        <br/>
        <p style={{ overflowWrap: 'break-word'}}>
            Referencia: Propuesta de servicios jurídicos profesionales - Honorarios Exp. <b>{data.filingNumber}</b>
        </p>
        <br/>
        <br/>
        Cordial saludo,
        <br/>
        <br/>
        <p style={{ overflowWrap: 'break-word'}}>
            Para <b>{data.legalCompanyText}</b> es muy grato presentar a usted la siguiente propuesta de servicios jurídicos, con 
            el fin de abordar los asumir la defensa técnica dentro de la investigación <b>{data.caseType}</b> No. <b>{data.filingNumber}</b> {data.observation}
        </p>
        Agradecemos de manera especial su confianza al permitirnos presentar la propuesta de asesoría de la referencia, esperando recoger las necesidades y expectativas de su parte:
        <br/>
        <br/>
        <b>ANTECEDENTES</b><br/>
        <p style={{ overflowWrap: 'break-word'}}>{data.summary}</p>
        <b>ALCANCE</b><br/>
        El alcance de nuestra asesoría abarca el análisis jurídico del caso para realizar la defensa técnica ante
        la Dirección Operativa de responsabilidad <b>{data.caseType}</b> de la <b>{data.researchOrgan.organId.description}</b> en <b>{data.instance}</b> instancia.  
        <br/>
        <br/>
        Nuestro servicio de asesoría legal estaría compuesto por los siguientes aspectos:
        <br/>
        &nbsp;&nbsp;&nbsp; &#8226; Análisis jurídico de la documentación aportada. <br/>
        &nbsp;&nbsp;&nbsp; &#8226; Reuniones virtuales o fisicas para sustentar la defensa técnica. <br/>
        &nbsp;&nbsp;&nbsp; &#8226; Preparación de los documentos para audiencia de descargos y de decisión. <br/>
        &nbsp;&nbsp;&nbsp; &#8226; Recopilación y análisis de las pruebas. <br/>
        &nbsp;&nbsp;&nbsp; &#8226; Representación administrativa ante el órgano de control. <br/>
        &nbsp;&nbsp;&nbsp; &#8226; Presentación de los recursos a que haya lugar. <br/>
        &nbsp;&nbsp;&nbsp; &#8226; Sustentación y controversia de las pruebas. <br/>
        &nbsp;&nbsp;&nbsp; &#8226; Notificación de autos y comunicados oficiales. <br/>
        <br/>
        <b>DURACIÓN</b>
        <br/>
        El plazo estimado para adelantar la asesoría es a término indefinido, contemplando dentro de este los términos de ley.     
        <br/>
        <br/>
        <b>VINCULACIÓN CIVIL</b>
        <br/>
        Entre el cliente y los Asesores existirá vinculación meramente civil; a favor de ésta y/o de sus colaboradores solo se causarán los honorarios pactados, sin lugar 
        a reajuste alguno salvo que se convengan coberturas diferentes a las aquí planteadas.
        <br/>
        <br/>
        <b>HONORARIOS Y FORMA DE PAGO</b>
        <br/>
        <div style={{display: 'inline'}}> Por la representación adminstrativa se causarán unos honorarios por valor de <b>{data.valueLetters}</b> ($<b> {new Intl.NumberFormat("es-CO").format(data.valueNumber)}</b>) </div>
        MAS IVA, que se pagarán a través de la entidad aseguradora en la siguiente forma de pago: 50% con el aviso de siniestro, y el otro 50% con el 
        auto por medio del cual se resuelva la investigación dentro del proceso de 
        responsabilidad <b>{data.caseType}</b> de <b>{data.instance}</b> instancia, o se obenga Auto de archivo o fallo sin responsabilidad. 
        <br/>
        <br/>
        NOTA: Los valores acordados serán consignados en la cuenta tipo <b>Ahorros</b> No. <b>{data.bankAccountNumberText}</b> del Banco <b>Davivienda</b>. 
        <br/>
        <br/>
        Los honorarios que se generen por <b>circunstancias adicionales</b> ligadas a la asesoría objeto de 
        esta oferta, no harán parte de la misma y serán pagados previa concertación a <b>{data.legalCompanyText}</b> en forma 
        independiente a los honorarios establecidos en este punto de la oferta.
        <br/>
        <br/>
        <Signature data={data.attorneyInCharge.userId.signature}/>
        {data.attorneyName.toUpperCase()}<br/>
        {data.positionText} <br/>
        {data.attorneyInCharge.userId.documentType} No {data.attorneyInCharge.userId.document} de Cali<br/>
        TP No {data.attorneyInCharge.userId.professionalCard} del C.S. Judicatura<br/>
        {data.attorneyInCharge.userId.email}<br/>
    </div>
);

const legalityDocument = ( data ) => (
    <div id="capture" style={{textAlign: 'justify', fontSize: '0.8em', lineHeight: 1.2}}>
        <br/>
        <h5 style={{width: '100%', textAlign: 'center'}}>FORMATO CONTROL DE LEGALIDAD</h5>
        <br/>
        <p>El presente documento tiene como objetivo tener claridad y analizar con detenimiento los autos de apertura de las diferentes investigaciones en donde nos corresponda ejercer defensa. Es necesario revisar las condiciones esenciales que confirman la legalidad de la actividad administrativa. La ilegalidad del acto se manifiesta cada vez que las condiciones esenciales están ausente.</p>
        <p>En ese sentido, a continuación se señalan las <b>cuantías</b> de contratación de CALI y PALMIRA, que deberán tenerse en cuenta al momento de calcular la cuantía en los respectivos procesos.</p>
        <b>CUANTÍAS CALI:</b>
        <br/>
        <ul>
            <li><b>Presupuesto:</b> CUATRO BILLONES SEISCIENTOS MIL SEISCIENTOS OCHENTA MILLONES TRESCIENTOS CINCUENTA Y OCHO MIL QUINIENTOS TREINTA Y OCHO PESOS ($ 4.600.680.358.538)</li>
            <li><b>Mínima cuantía:</b> CIEN MILLONES DE PESOS ($100.000.000)</li>
            <li><b>Menor cuantía:</b> HASTA MIL MILLONES DE PESOS ($1.000.000.000,00) </li>
            <li><b>Mayor cuantía:</b> Todo lo que supere la menor cuantía. (&gt;1.000.000.000,00)</li>
        </ul>
        <b>INSTANCIAS CALI:</b>
        <br/>
        <ul>
            <li><b>Única Instancia:</b> &#61; o &lt; 1.000.000.000,00 (Igual o menor a mil millones de pesos)</li>
            <li><b>Doble instancia:</b> Todo lo que supere MIL MILLONES DE PESOS. (&gt;1.000.000.000,00)</li>
        </ul>
        <b>CUANTÍAS PALMIRA:</b>
        <br/>
        <ul>
            <li><b>Presupuesto:</b> QUINIENTOS OCHENTA Y SEIS MIL VEINTIOCHO MILLONES QUINIENTOS SETENTA MIL QUINIENTOS NOVENTA Y TRES PESOS ($586.028.570.593)</li>
            <li><b>Mínima cuantía:</b> SESENTA Y CINCO MILLONES ($65.000.000)</li>
            <li><b>Menor cuantía:</b> HASTA SEISCIENTOS CINCUENTA MILLONES ($650.000.000) </li>
            <li><b>Mayor cuantía:</b> Todo lo que supere 650 millones de pesos (&gt;650.000.000)</li>
        </ul>
        <b>INSTANCIAS PALMIRA:</b>
        <br/>
        <ul>
            <li><b>Única Instancia:</b> &#61; o &lt; 650.000.000 (Igual o menor a seiscientos cincuenta millones)</li>
            <li><b>Doble instancia:</b> Todo lo que supere 650 millones de pesos. (&gt;650.000.000)</li>
        </ul>
        <p><b>De acuerdo con el artículo 110 de la Ley 1474 de 2011, las instancias en el proceso de responsabilidad fiscal son:</b></p>
        <p><b>ARTÍCULO 110. INSTANCIAS.</b> El proceso de responsabilidad fiscal será de única instancia cuando la cuantía del presunto daño patrimonial estimado en el auto de apertura e imputación o de imputación de responsabilidad fiscal, según el caso, sea igual o inferior a la menor cuantía para contratación de la respectiva entidad afectada con los hechos y será de doble instancia cuando supere la suma señalada.</p>
        <p><b>PARÁGRAFO 1o.</b> Cuando el presunto daño patrimonial afecte más de una entidad pública, el número de instancias procesales se definirá tomando como base la cuantía para contratación de la entidad que tenga mayor presupuesto oficial.</p>
        <p style={{color: 'red'}}><b style={{ color: 'black'}}>PARÁGRAFO 2o.</b> Serán de doble instancia, los procesos de responsabilidad fiscal que se adelanten con entidades afectadas cuya contratación no esté clasificada por cuantías.</p>
        <p><b>De acuerdo con el artículo 112 de la Ley 1474 de 2011, la forma de notificar en el proceso de responsabilidad fiscal son:</b></p>
        <p><b>ARTÍCULO 112. CITACIONES Y NOTIFICACIONES.</b> Cuando se deba notificar personalmente una decisión, o convocarse a la celebración de una audiencia se citará oportunamente a las partes, al garante, testigos, peritos y demás personas que deban intervenir en la actuación.</p>
        <p>El presunto responsable y su apoderado si lo tuviere, o el defensor de oficio, y el garante en calidad de tercero civilmente responsable, tendrán la obligación procesal de señalar la dirección, el correo electrónico o cualquier otro medio idóneo de comunicación, en el cual se recibirán las citaciones. Igualmente tendrán el deber de informar cualquier cambio que se presente en el curso del proceso. Cuando se haga un cambio de dirección, el funcionario responsable deberá hacer en forma inmediata el respectivo registro, so pena de sanción de conformidad con lo establecido en el Código Único Disciplinario. La omisión a este deber implicará que sean legalmente válidas las comunicaciones que se envíen a la última dirección conocida.</p>
        <p>La citación debe indicar la clase de diligencia para la cual se le requiere, el lugar, la fecha y hora en donde se llevará a cabo y el número de radicación de la actuación a la cual corresponde.</p>

        <div style={{border: '1px solid black', display: 'flex', flexDirection: 'column'}}>
            <h5 style={{width: '100%', textAlign: 'center', fontSize: '.8rem', padding: 0, paddingTop: '.5rem', paddingBottom: '.5rem', borderBottom: '1px solid black', margin: 0}}><b>CONTROL DE LEGALIDAD</b></h5>
            <div style={{ display: 'flex', flexWrap: 'wrap'}}>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>1. DOCUMENTO</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.legalityControl.typeText}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>2. ÓRGANO</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.researchOrgan.organId.description}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>3. TIPO DE PROCESO</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.caseType}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>4. RADICADO</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.filingNumber}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>5.1. INVESTIGADOS ¿Están plena y correctamente identificados en el auto?</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.clientText}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>6. ENTIDAD AFECTADA</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.entityText}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>7.1.IDENTIFICACIÓN DE COMPAÑÍA ASEGURADORA, 7.2. NÚMERO DE PÓLIZA Y 7.3. DEL VALOR ASEGURADO.</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.companyText} - POLIZA No. {data.legalityControl.policyNumber} - VALOR: ${data.legalityControl.insuredValue}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>8. CUANTÍA</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.legalityControl.amount}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>9. # INSTANCIAS</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.legalityControl.instance}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>10. PRUEBAS</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.legalityControl.proof}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>11. ACREDITACIÓN DE ELEMENTOS DEL DAÑO</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.legalityControl.elementsOfDamage}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>12. RECUSACIÓN/IMPEDIMENTOS (Artículo 130 Ley 1437 de 2011) Observar si algún miembro del equipo auditor está dentro de la mesa de funcionarios que gestionan la audiencia.</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.legalityControl.recusation}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>13. CAUSALES DE NULIDAD</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.legalityControl.nullity}</div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem', borderRight: '1px solid black' }}> <b>14. ESTADO DEL TÉRMINO DE CADUCIDAD DE LA ACCIÓN Y PRESCRIPCIÓN</b> </div>
                <div style={{ flex: '50%', borderBottom: '1px solid black', textAlign: 'center', padding: '.5rem' }}>{data.legalityControl.expiration}</div>
                <div style={{ flex: '50%', textAlign: 'center', padding: '.8rem', borderRight: '1px solid black' }}> <b>15. CONDUCTA ENDILGADA</b> </div>
                <div style={{ flex: '50%', textAlign: 'center', padding: '.8rem' }}>{data.legalityControl.foisted}</div>
            </div>
        </div>
        <br/>
        <br/>
        <Signature data={data.legalityControl.reviewedUser.signature}/>
        {data.reviewedUserText.toUpperCase()}<br/>
        {data.legalityControl.reviewedUser.documentType} No {data.legalityControl.reviewedUser.document} de Cali<br/>
        {data.legalityControl.reviewedUser.email}<br/>
    </div>
);